import { createTextVNode as _createTextVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, vShow as _vShow, withDirectives as _withDirectives, createBlock as _createBlock, resolveDirective as _resolveDirective } from "vue"

const _hoisted_1 = { class: "order-form" }
const _hoisted_2 = { class: "order-title" }
const _hoisted_3 = {
  class: "form-container",
  "element-loading-text": "Загрузка..."
}
const _hoisted_4 = { class: "form-actions" }
const _hoisted_5 = { class: "agreement-dialog-content" }
const _hoisted_6 = { class: "dialog-footer" }
const _hoisted_7 = { class: "dialog-footer" }
const _hoisted_8 = { class: "order-amount-dialog-content" }
const _hoisted_9 = { class: "order-amount-details" }
const _hoisted_10 = { class: "detail-row" }
const _hoisted_11 = { class: "detail-value" }
const _hoisted_12 = {
  key: 0,
  class: "detail-row"
}
const _hoisted_13 = { class: "detail-value" }
const _hoisted_14 = {
  key: 1,
  class: "detail-row"
}
const _hoisted_15 = {
  key: 0,
  class: "detail-value"
}
const _hoisted_16 = {
  key: 1,
  class: "detail-value"
}
const _hoisted_17 = {
  key: 2,
  class: "detail-row"
}
const _hoisted_18 = { class: "detail-value" }
const _hoisted_19 = { class: "dialog-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_step = _resolveComponent("el-step")!
  const _component_el_steps = _resolveComponent("el-steps")!
  const _component_order_details = _resolveComponent("order-details")!
  const _component_sender_information = _resolveComponent("sender-information")!
  const _component_payee_information = _resolveComponent("payee-information")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("h2", _hoisted_2, [
      (!_ctx.currentOrder.id)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createTextVNode(" Новый заказ ")
          ], 64))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createTextVNode(" Заказ #" + _toDisplayString(_ctx.currentOrder.order_number) + " на " + _toDisplayString(_ctx.currentOrder.amount) + " " + _toDisplayString(_ctx.currentOrder.currency), 1)
          ], 64))
    ]),
    _createVNode(_component_el_steps, {
      active: _ctx.activeStep,
      "finish-status": "success",
      "align-center": ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_step, { title: "Сумма заказа" }),
        _createVNode(_component_el_step, { title: "Данные отправителя" }),
        _createVNode(_component_el_step, { title: "Данные получателя" })
      ]),
      _: 1
    }, 8, ["active"]),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_3, [
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_order_details)
      ], 512), [
        [_vShow, _ctx.activeStep === 0]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_sender_information)
      ], 512), [
        [_vShow, _ctx.activeStep === 1]
      ]),
      _withDirectives(_createElementVNode("div", null, [
        _createVNode(_component_payee_information)
      ], 512), [
        [_vShow, _ctx.activeStep === 2]
      ]),
      _createElementVNode("div", _hoisted_4, [
        (_ctx.activeStep > 0)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              onClick: _ctx.prevStep
            }, {
              default: _withCtx(() => _cache[4] || (_cache[4] = [
                _createTextVNode("Назад")
              ])),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true),
        (_ctx.activeStep < 2)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 1,
              type: "primary",
              onClick: _ctx.nextStep,
              disabled: !_ctx.isCurrentStepValid,
              loading: _ctx.loading
            }, {
              default: _withCtx(() => _cache[5] || (_cache[5] = [
                _createTextVNode(" Вперед ")
              ])),
              _: 1
            }, 8, ["onClick", "disabled", "loading"]))
          : _createCommentVNode("", true),
        (_ctx.activeStep === 2)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              type: "primary",
              onClick: _ctx.completeOrder,
              disabled: !_ctx.isCurrentStepValid,
              loading: _ctx.loading
            }, {
              default: _withCtx(() => _cache[6] || (_cache[6] = [
                _createTextVNode(" Оформить заказ ")
              ])),
              _: 1
            }, 8, ["onClick", "disabled", "loading"]))
          : _createCommentVNode("", true)
      ])
    ])), [
      [_directive_loading, _ctx.loading]
    ]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showAgreementDialog,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showAgreementDialog) = $event)),
      title: _ctx.agreementDialogTitle,
      width: "90%",
      class: "responsive-dialog",
      center: "",
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      "show-close": false
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.currentOrder.id && _ctx.currentOrder.sender)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                tag: "a",
                href: `/api/orders/${_ctx.currentOrder.id}/download-agreement`,
                target: "_blank"
              }, {
                default: _withCtx(() => _cache[7] || (_cache[7] = [
                  _createTextVNode(" Скачать ")
                ])),
                _: 1
              }, 8, ["href"]))
            : _createCommentVNode("", true),
          _createVNode(_component_el_button, { onClick: _ctx.continueAfterAgreementDialog }, {
            default: _withCtx(() => _cache[8] || (_cache[8] = [
              _createTextVNode("Далее")
            ])),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("p", null, _toDisplayString(_ctx.agreementDialogMessage), 1)
        ])
      ]),
      _: 1
    }, 8, ["modelValue", "title"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showDocumentsReadyDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.showDocumentsReadyDialog) = $event)),
      title: "Поручение и счет готовы",
      width: "90%",
      class: "responsive-dialog",
      center: "",
      "close-on-click-modal": true,
      "close-on-press-escape": true,
      "show-close": true,
      onClosed: _ctx.handleDocumentsDialogClosed
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_el_button, {
            type: "primary",
            tag: "a",
            href: `/api/orders/${_ctx.currentOrder.id}/download-assignment`,
            target: "_blank"
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode(" Скачать поручение ")
            ])),
            _: 1
          }, 8, ["href"]),
          _createVNode(_component_el_button, {
            type: "primary",
            tag: "a",
            href: `/api/orders/${_ctx.currentOrder.id}/download-invoice`,
            target: "_blank"
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode(" Скачать счет ")
            ])),
            _: 1
          }, 8, ["href"])
        ])
      ]),
      default: _withCtx(() => [
        _cache[11] || (_cache[11] = _createElementVNode("div", { class: "documents-dialog-content" }, [
          _createElementVNode("p", null, "Поручение и счет для вашего заказа готовы. Вы можете скачать их, нажав на соответствующие кнопки.")
        ], -1))
      ]),
      _: 1
    }, 8, ["modelValue", "onClosed"]),
    _createVNode(_component_el_dialog, {
      modelValue: _ctx.showOrderAmountDialog,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.showOrderAmountDialog) = $event)),
      title: "Информация о заказе",
      width: "90%",
      class: "responsive-dialog",
      center: "",
      "close-on-click-modal": true,
      "close-on-press-escape": true,
      "show-close": true
    }, {
      footer: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_component_el_button, {
            type: "primary",
            onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showOrderAmountDialog = false))
          }, {
            default: _withCtx(() => _cache[17] || (_cache[17] = [
              _createTextVNode("Продолжить")
            ])),
            _: 1
          })
        ])
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_8, [
          _cache[16] || (_cache[16] = _createElementVNode("h3", null, "Детали заказа", -1)),
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _cache[12] || (_cache[12] = _createElementVNode("span", { class: "detail-label" }, "Сумма заказа:", -1)),
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.currentOrder.amount) + " " + _toDisplayString(_ctx.currentOrder.currency), 1)
            ]),
            (_ctx.currentOrder.convertation_commission)
              ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                  _cache[13] || (_cache[13] = _createElementVNode("span", { class: "detail-label" }, "Комиссия агента:", -1)),
                  _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.currentOrder.convertation_commission * 100) + "%", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentOrder.swift_commission)
              ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                  _cache[14] || (_cache[14] = _createElementVNode("span", { class: "detail-label" }, "Комиссия SWIFT:", -1)),
                  (_ctx.currentOrder.swift_commission > 1)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_ctx.currentOrder.swift_commission) + " " + _toDisplayString(_ctx.currentOrder.currency), 1))
                    : (_openBlock(), _createElementBlock("span", _hoisted_16, _toDisplayString(_ctx.currentOrder.swift_commission * 100) + "%", 1))
                ]))
              : _createCommentVNode("", true),
            (_ctx.currentOrder.amount_to_pay)
              ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                  _cache[15] || (_cache[15] = _createElementVNode("span", { class: "detail-label" }, "К оплате рублями:", -1)),
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.currentOrder.amount_to_pay), 1)
                ]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}